import {lazy} from "react";

export const LiveAsync = lazy(() => import('./Live'))
